module.exports = __webpack_public_path__ + "static/how-to-create-contest__step-1-71a04077cb653eb7da63b34afcff5e6f.png";